import { render } from "./MainNav.vue?vue&type=template&id=01d7df3a"
import script from "./MainNav.vue?vue&type=script&lang=js"
export * from "./MainNav.vue?vue&type=script&lang=js"

import "./MainNav.vue?vue&type=style&index=0&id=01d7df3a&lang=css"

import exportComponent from "/Users/brian/Documents/web-projects/clients/andy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__